/**
 * rte-normalize.js
 * Converts <br>-separated text in .rte blocks into proper <p> tags.
 * Leaves headings, lists, blockquotes, and other block elements untouched.
 */
(function () {
  var BLOCK = /^<(h[1-6]|ul|ol|li|dl|dt|dd|blockquote|div|table|pre|figure|address)/i;

  function normalize(el) {
    var html = el.innerHTML.trim();

    // Nothing to do if there are no <br> tags
    if (!/<br/i.test(html)) return;

    // Split on one or more consecutive <br> tags
    var chunks = html.split(/<br\s*\/?>\s*(?:<br\s*\/?>)*/gi);

    el.innerHTML = chunks
      .map(function (chunk) {
        chunk = chunk.trim();
        if (!chunk) return '';
        // Leave block-level elements unwrapped
        if (BLOCK.test(chunk)) return chunk;
        return '<p>' + chunk + '</p>';
      })
      .join('');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rte').forEach(normalize);
  });
})();
